import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  GeneralErrandSubTypeConfig,
  GeneralErrandTypeConfig,
  type GeneralErrandSubType,
  type GeneralErrandType,
} from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
import { Badge } from '@/components/ui/badge';

type GeneralErrandTypeItem = (
  isSubType?: boolean
) => RelationFieldProps<GeneralErrandType | GeneralErrandSubType>;

export const getGeneralErrandTypeItem: GeneralErrandTypeItem = (isSubType) => {
  const nested = isSubType
    ? getRelationFieldNames(GeneralErrandSubTypeConfig)
    : getRelationFieldNames(GeneralErrandTypeConfig);
  return {
    nested: nested as (keyof (GeneralErrandType | GeneralErrandSubType))[],
    renderItem: (item: GeneralErrandType | GeneralErrandSubType) => ({
      title: item.name ?? '',
      descriptionItems: item.isActive ? (
        <Badge variant='green'>Aktiv</Badge>
      ) : (
        <Badge variant='light-gray'>Inaktiv</Badge>
      ),
    }),
  };
};
